var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { sortByFunc } from '../../../../utils/helper/lodash_replacements';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { FunnelMixedFilter } from './FunnelMixedFilter';
export class FunnelMixed {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get funnel() {
        return this.parent;
    }
    get app() {
        return this.funnel.app;
    }
    get mixedFilter() {
        return new FunnelMixedFilter(this);
    }
    get miniQuestionsMixedSorted() {
        return this.mixedFilter.filteredMixedMiniQuestions
            .concat()
            .sort(sortByFunc((mini) => mini.miniMixedScore.scoreTotal))
            .reverse();
    }
}
__decorate([
    memoize
], FunnelMixed.prototype, "mixedFilter", null);
__decorate([
    computed
], FunnelMixed.prototype, "miniQuestionsMixedSorted", null);
